import React, { useEffect, useState } from 'react';
import axios from 'axios';
import LayoutUserHeader from '../components/LayoutUserHeader';
import LayoutUserFooter from '../components/LayoutUserFooter';
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Avatar,
  Stack,
  Container,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Alert
} from '@mui/material';
import ReceiptIcon from '@mui/icons-material/Receipt';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import PaymentIcon from '@mui/icons-material/Payment';
import GSTLoader from '../components/GSTLoader';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const UserDashboard = () => {
  const [stats, setStats] = useState(null);

const [allStats, setAllStats] = useState(null);

const [filteredStats, setFilteredStats] = useState(null);

const [financialYear, setFinancialYear] = useState("");

const [noData, setNoData] = useState(false);

  const [loading, setLoading] = useState(true);

  // --- Function to recalc purchase totals from uploaded invoices
  const refreshStatsFromInvoices = (invoiceList) => {
    if (!invoiceList || !invoiceList.length) return;

    // Initialize months to ensure consistent order
    const months = [
      "Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"
    ];
    const purchaseInvoicesFYMonthly = months.map((m) => ({ month: m, count: 0, amount: 0 }));

    invoiceList.forEach(inv => {
      //const month = new Date(inv.InvoiceDate).toLocaleString('default', { month: 'short' });
      const date = new Date(inv.InvoiceDate);

const month = date.toLocaleString('en-IN', {
  month: 'short',
  timeZone: 'Asia/Kolkata'
});
      const index = purchaseInvoicesFYMonthly.findIndex(m => m.month === month);
      if (index !== -1) {
        purchaseInvoicesFYMonthly[index].count += 1;
        // purchaseInvoicesFYMonthly[index].amount += parseFloat(inv.TotalAmount || 0);
        purchaseInvoicesFYMonthly[index].amount += parseFloat(
          String(inv.TotalAmount?.$numberDecimal || inv.TotalAmount || 0)
          );
      }
    });

    const totalPurchaseInvoices = invoiceList.length;
    // const totalPurchaseAmount = invoiceList.reduce((sum, inv) => sum + parseFloat(inv.TotalAmount || 0), 0);
    const totalPurchaseAmount = invoiceList.reduce((sum, inv) => sum + parseFloat(
      String(inv.TotalAmount?.$numberDecimal || inv.TotalAmount || 0)
      ), 0);

    setStats(prev => ({
      ...prev,
      totalPurchaseInvoices,
      totalPurchaseAmount,
      purchaseInvoicesFYMonthly
    }));
  };

  // --- Fetch dashboard data initially
  useEffect(() => {
    const gstNumber = localStorage.getItem("gstNumber");
    if (!gstNumber) return;

    const fetchDashboardStats = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${BASE_URL}/dashboard/stats`, {
          params: { gstNumber },
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = response.data;

       const mappedData = {
    totalSaleInvoices: data.SaleReport.reduce((acc, cur) => acc + cur.invoices, 0),
    totalSaleAmount: data.SaleReport.reduce((acc, cur) => acc + cur.amount, 0),
    totalPurchaseInvoices: data.PurchaseReport.reduce((acc, cur) => acc + cur.invoices, 0),
    totalPurchaseAmount: data.PurchaseReport.reduce((acc, cur) => 
        acc + parseFloat(String(cur.amount?.$numberDecimal || cur.amount || 0))
    , 0),

    //financialYear: data.FinancialYear,
    financialYear: data.FinancialYear || "",
    saleInvoicesFYMonthly: data.SaleReport.map(item => ({
        month: item.month,
        count: item.invoices,
        amount: item.amount
    })),
    purchaseInvoicesFYMonthly: data.PurchaseReport.map(item => ({
        month: item.month,
        count: item.invoices,
        amount: parseFloat(String(item.amount?.$numberDecimal || item.amount || 0)) // <-- Fixed parsing logic
    })) // <-- Correctly ends here
}; // <-- Ends the mappedData object
        
        setStats(mappedData);
        setAllStats(mappedData);
      } catch (error) {
        console.error("Failed to fetch dashboard stats:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardStats();

    // --- Event listener for refreshing dashboard from uploaded invoices
    const handleRefresh = (e) => {
      const updatedInvoices = e.detail;
      refreshStatsFromInvoices(updatedInvoices);
    };

    window.addEventListener('refreshDashboard', handleRefresh);
    return () => window.removeEventListener('refreshDashboard', handleRefresh);

  }, []);

  // const dashboardStats = stats
  //   ? [
  //       {
  //         title: 'Total Sale Invoices',
  //         value: stats.totalSaleInvoices || 0,
  //         gradient: 'linear-gradient(135deg, #6dd5fa, #2980b9)',
  //         icon: <ReceiptIcon sx={{ color: '#fff', fontSize: 36 }} />,
  //       },
  //       {
  //         title: 'Total Sale Amount',
  //         value: `₹${Number(stats.totalSaleAmount || 0).toLocaleString()}`,
  //         gradient: 'linear-gradient(135deg, #fbc531, #e1b12c)',
  //         icon: <AttachMoneyIcon sx={{ color: '#fff', fontSize: 36 }} />,
  //       },
  //       {
  //         title: 'Total Purchase Invoices',
  //         value: stats.totalPurchaseInvoices || 0,
  //         gradient: 'linear-gradient(135deg, #00b894, #0984e3)',
  //         icon: <ShoppingCartIcon sx={{ color: '#fff', fontSize: 36 }} />,
  //       },
  //       {
  //         title: 'Total Purchase Amount',
  //         value: `₹${Number(stats.totalPurchaseAmount || 0).toLocaleString()}`,
  //         gradient: 'linear-gradient(135deg, #a29bfe, #6c5ce7)',
  //         icon: <PaymentIcon sx={{ color: '#fff', fontSize: 36 }} />,
  //       },
  //     ]
  //   : [];

const currentData = financialYear && filteredStats
  ? filteredStats
  : stats;

const dashboardStats = currentData
  ? [
      {
        title: 'Total Sale Invoices',
        value: currentData.totalSaleInvoices || 0,
        gradient: 'linear-gradient(135deg, #6dd5fa, #2980b9)',
        icon: <ReceiptIcon sx={{ color: '#fff', fontSize: 36 }} />,
      },
      {
        title: 'Total Sale Amount',
        value: `₹${Number(currentData.totalSaleAmount || 0).toLocaleString()}`,
        gradient: 'linear-gradient(135deg, #fbc531, #e1b12c)',
        icon: <AttachMoneyIcon sx={{ color: '#fff', fontSize: 36 }} />,
      },
      {
        title: 'Total Purchase Invoices',
        value: currentData.totalPurchaseInvoices || 0,
        gradient: 'linear-gradient(135deg, #00b894, #0984e3)',
        icon: <ShoppingCartIcon sx={{ color: '#fff', fontSize: 36 }} />,
      },
      {
        title: 'Total Purchase Amount',
        value: `₹${Number(currentData.totalPurchaseAmount || 0).toLocaleString()}`,
        gradient: 'linear-gradient(135deg, #a29bfe, #6c5ce7)',
        icon: <PaymentIcon sx={{ color: '#fff', fontSize: 36 }} />,
      },
    ]
  : [];



const financialYears = [
  "2024-2025",
  "2025-2026",
  "2026-2027",
  "2027-2028",
  // "2028-2029",
  // "2029-2030"
];


// const filterFinancialYearData = (fy, data) => {

//   if (!data) return;

//   const startYear = fy.split("-")[0];
//   const endYear = fy.split("-")[1];

//   const filteredSale = data.saleInvoicesFYMonthly.filter(item => {

//     return (
//       item.month.includes(startYear) ||
//       item.month.includes(endYear)
//     );

//   });

//   const filteredPurchase = data.purchaseInvoicesFYMonthly.filter(item => {

//     return (
//       item.month.includes(startYear) ||
//       item.month.includes(endYear)
//     );

//   });

//   const filteredData = {

//     ...data,

//     saleInvoicesFYMonthly: filteredSale,

//     purchaseInvoicesFYMonthly: filteredPurchase,

//     totalSaleInvoices: filteredSale.reduce((a, b) => a + b.count, 0),

//     totalSaleAmount: filteredSale.reduce((a, b) => a + b.amount, 0),

//     totalPurchaseInvoices: filteredPurchase.reduce((a, b) => a + b.count, 0),

//     totalPurchaseAmount: filteredPurchase.reduce((a, b) => a + b.amount, 0),

//   };

//   const hasData =
//     filteredData.totalSaleInvoices > 0 ||
//     filteredData.totalPurchaseInvoices > 0;

//   setNoData(!hasData);

//   setStats(filteredData);
// };



const handleFinancialYearChange = (e) => {

  const selectedFY = e.target.value;

  // RESET DASHBOARD
  if (!selectedFY) {

    setFinancialYear("");

    setFilteredStats(null);

    setNoData(false);

    return;
  }

  setFinancialYear(selectedFY);

  if (!allStats) return;

  const [startYear, endYear] = selectedFY.split("-");

  // ==========================================
  // SALE FILTER
  // ==========================================

  const filteredSale =
    allStats.saleInvoicesFYMonthly.filter(item => {

      const [monthName, year] = item.month.split("-");

      const yearNum = parseInt(year);

      const monthsAprToDec = [
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ];

      const monthsJanToMar = [
        "Jan",
        "Feb",
        "Mar"
      ];

      return (
        (
          yearNum === parseInt(startYear) &&
          monthsAprToDec.includes(monthName)
        )
        ||
        (
          yearNum === parseInt(endYear) &&
          monthsJanToMar.includes(monthName)
        )
      );

    });

  // ==========================================
  // PURCHASE FILTER
  // ==========================================

  const filteredPurchase =
    allStats.purchaseInvoicesFYMonthly.filter(item => {

      const [monthName, year] = item.month.split("-");

      const yearNum = parseInt(year);

      const monthsAprToDec = [
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ];

      const monthsJanToMar = [
        "Jan",
        "Feb",
        "Mar"
      ];

      return (
        (
          yearNum === parseInt(startYear) &&
          monthsAprToDec.includes(monthName)
        )
        ||
        (
          yearNum === parseInt(endYear) &&
          monthsJanToMar.includes(monthName)
        )
      );

    });

  // ==========================================
  // FINAL FILTERED DATA
  // ==========================================

  const filteredData = {

    ...allStats,

    saleInvoicesFYMonthly: filteredSale,

    purchaseInvoicesFYMonthly: filteredPurchase,

    totalSaleInvoices:
      filteredSale.reduce((a, b) => a + b.count, 0),

    totalSaleAmount:
      filteredSale.reduce((a, b) => a + b.amount, 0),

    totalPurchaseInvoices:
      filteredPurchase.reduce((a, b) => a + b.count, 0),

    totalPurchaseAmount:
      filteredPurchase.reduce((a, b) => a + b.amount, 0),

  };

  const hasData =
    filteredData.totalSaleInvoices > 0 ||
    filteredData.totalPurchaseInvoices > 0;

  setNoData(!hasData);

  setFilteredStats(filteredData);

};
  return (
    <GSTLoader>
      <div>
        <LayoutUserHeader />

        <Box sx={{ px: 3, py: 6, bgcolor: '#f4f6f8', minHeight: '80vh' }}>
          <Typography
            variant="h4"
            fontWeight="bold"
            align="center"
            sx={{ mb: 6, fontFamily: "'Poppins', sans-serif", color: '#2d3436' }}
          >
            Dashboard Overview
          </Typography>

          <Container maxWidth="xl">
            {loading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '30vh' }}>
                <CircularProgress />
              </Box>
            ) : (
              <>
                {/* Top Stats Cards */}

<Box
  sx={{
    display: 'flex',
    justifyContent: 'flex-end',
    mb: 4
  }}
>

  <FormControl sx={{ minWidth: 260 }}>

    <InputLabel>
      Please Select Financial Year
    </InputLabel>

    <Select
  value={financialYear}
  label="Please Select Financial Year"
  onChange={handleFinancialYearChange}
>

  <MenuItem value="">
    Please Select Financial Year
  </MenuItem>

  {financialYears.map((fy) => (

    <MenuItem key={fy} value={fy}>
      {fy}
    </MenuItem>

  ))}

</Select>

  </FormControl>

</Box>


{noData && (

  <Alert severity="warning" sx={{ mb: 3 }}>

    No Data Found

  </Alert>

)}

                <Grid container spacing={4} justifyContent="center">
                  {dashboardStats.map((stat, index) => (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                      <Card
                        sx={{
                          background: stat.gradient,
                          borderRadius: 4,
                          boxShadow: 6,
                          height: 130,
                          transition: 'transform 0.3s, box-shadow 0.3s',
                          '&:hover': { transform: 'translateY(-8px)', boxShadow: 10 },
                        }}
                      >
                        <CardContent>
                          <Stack direction="row" spacing={3} alignItems="center">
                            <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.2)', width: 64, height: 64 }}>
                              {stat.icon}
                            </Avatar>
                            <Box>
                              <Typography variant="h6" sx={{ color: '#fff', fontWeight: 600 }}>
                                {stat.title}
                              </Typography>
                              <Typography variant="h5" sx={{ color: '#fff', fontWeight: 'bold', mt: 1 }}>
                                {stat.value}
                              </Typography>
                            </Box>
                          </Stack>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
                </Grid>

                {/* Sale Invoices Monthly */}
                {/* <Box sx={{ mt: 6, p: 3, bgcolor: '#fff', borderRadius: 4, boxShadow: 3 }}>
                  <Typography variant="h6" fontWeight="bold" sx={{ color: '#2d3436', mb: 3 }}>
                    Sale Invoices - Monthly (FY {stats.financialYear})
                  </Typography>
                  <Grid container spacing={3}>
                    {filteredStats?.saleInvoicesFYMonthly.map((item, index) => (
                      <Grid item xs={12} sm={6} md={4} key={`sale-${index}`}>
                        <Card
                          sx={{
                            p: 2,
                            borderRadius: 3,
                            boxShadow: 2,
                            background: 'linear-gradient(135deg, #74b9ff, #0984e3)',
                            color: '#fff',
                            transition: 'transform 0.3s',
                            '&:hover': { transform: 'scale(1.05)', boxShadow: 5 },
                          }}
                        >
                          <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>{item.month}</Typography>
                          <Typography variant="body2">Invoices: {item.count}</Typography>
                          <Typography variant="body2">Amount: ₹{Number(item.amount).toLocaleString()}</Typography>
                        </Card>
                      </Grid>
                    ))}
                  </Grid>
                </Box> */}

                {/* Purchase Invoices Monthly */}
                {/* <Box sx={{ mt: 6, p: 3, bgcolor: '#fff', borderRadius: 4, boxShadow: 3 }}>
                  <Typography variant="h6" fontWeight="bold" sx={{ color: '#2d3436', mb: 3 }}>
                    Purchase Invoices - Monthly (FY {stats.financialYear})
                  </Typography>
                  <Grid container spacing={3}>
                    {filteredStats?.purchaseInvoicesFYMonthly.map((item, index) => (
                      <Grid item xs={12} sm={6} md={4} key={`purchase-${index}`}>
                        <Card
                          sx={{
                            p: 2,
                            borderRadius: 3,
                            boxShadow: 2,
                            background: 'linear-gradient(135deg, #55efc4, #00b894)',
                            color: '#fff',
                            transition: 'transform 0.3s',
                            '&:hover': { transform: 'scale(1.05)', boxShadow: 5 },
                          }}
                        >
                          <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>{item.month}</Typography>
                          <Typography variant="body2">Invoices: {item.count}</Typography>
                          <Typography variant="body2">Amount: ₹{Number(item.amount).toLocaleString()}</Typography>
                        </Card>
                      </Grid>
                    ))}
                  </Grid>
                </Box> */}

{financialYear && filteredStats && (
  <>

    {/* Sale Invoices Monthly */}
    <Box sx={{ mt: 6, p: 3, bgcolor: '#fff', borderRadius: 4, boxShadow: 3 }}>
      
      <Typography
        variant="h6"
        fontWeight="bold"
        sx={{ color: '#2d3436', mb: 3 }}
      >
        Sale Invoices - Monthly ({financialYear})
      </Typography>

      <Grid container spacing={3}>
        {filteredStats.saleInvoicesFYMonthly.map((item, index) => (
          
          <Grid item xs={12} sm={6} md={4} key={`sale-${index}`}>
            
            <Card
              sx={{
                p: 2,
                borderRadius: 3,
                boxShadow: 2,
                background: 'linear-gradient(135deg, #74b9ff, #0984e3)',
                color: '#fff',
              }}
            >
              <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                {item.month}
              </Typography>

              <Typography variant="body2">
                Invoices: {item.count}
              </Typography>

              <Typography variant="body2">
                Amount: ₹{Number(item.amount).toLocaleString()}
              </Typography>

            </Card>

          </Grid>

        ))}
      </Grid>
    </Box>


    {/* Purchase Invoices Monthly */}
    <Box sx={{ mt: 6, p: 3, bgcolor: '#fff', borderRadius: 4, boxShadow: 3 }}>
      
      <Typography
        variant="h6"
        fontWeight="bold"
        sx={{ color: '#2d3436', mb: 3 }}
      >
        Purchase Invoices - Monthly ({financialYear})
      </Typography>

      <Grid container spacing={3}>
        {filteredStats.purchaseInvoicesFYMonthly.map((item, index) => (
          
          <Grid item xs={12} sm={6} md={4} key={`purchase-${index}`}>
            
            <Card
              sx={{
                p: 2,
                borderRadius: 3,
                boxShadow: 2,
                background: 'linear-gradient(135deg, #55efc4, #00b894)',
                color: '#fff',
              }}
            >
              <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                {item.month}
              </Typography>

              <Typography variant="body2">
                Invoices: {item.count}
              </Typography>

              <Typography variant="body2">
                Amount: ₹{Number(item.amount).toLocaleString()}
              </Typography>

            </Card>

          </Grid>

        ))}
      </Grid>

    </Box>

  </>
)}



              </>
            )}
          </Container>
        </Box>

        <LayoutUserFooter />
      </div>
    </GSTLoader>
  );
};

export default UserDashboard;
